/**
 * Site-wide service worker registration (Django + static HTML).
 * Uses dynamic import so production bundles can minify exports (e.g. registerServiceWorker → r)
 * without breaking static `import { registerServiceWorker }`.
 */
if (typeof window.STATIC_URL === 'undefined') {
  const body = document.body;
  window.STATIC_URL = body?.dataset?.staticUrl || '';
}

(async () => {
  try {
    const body = document.body;
    const explicitSwUrl = body?.dataset?.swRegistrationUrl?.trim();
    const staticUrl = window.STATIC_URL || '';
    const swPath = explicitSwUrl
      ? explicitSwUrl
      : staticUrl
        ? `${staticUrl}src/js/sw-registration.js`
        : '/src/js/sw-registration.js';

    const mod = await import(/* @vite-ignore */ swPath);
    const register = mod.registerServiceWorker ?? mod.default ?? mod.r;
    if (typeof register === 'function') {
      register();
    } else {
      throw new Error('registerServiceWorker not found on sw-registration module');
    }
  } catch (error) {
    console.warn('[site-sw-registration-init] Service worker registration failed:', error);
  }
})();
